import { useState, useEffect, useRef } from 'react';
import { useStore } from '@betgames/bg-state-manager';
import { useAfterUpdate } from '@betgames/bg-tools';
import { GameId } from '@bg-shared/enums/GameId';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { IPlayerWonModel } from '@bg-shared/business/PlayerWon/interfaces';
import { playerWonEntity } from '../PlayerWon.entity';
import { playerWonEvents } from '../PlayerWon.events';

interface IPlayerWonCallback {
    (wonInfo: IPlayerWonModel, identifier: number): void;
}

export const usePlayerWon = (
    gameId: GameId,
    delay = 0,
    callback: IPlayerWonCallback = undefined,
): number => {
    const [lastIdentifier, setLastIdentifier] = useState<number>(null);
    const wonInfo = useStore(playerWonEntity.store(gameId));
    const delayRef = useRef<number>(delay);

    delayRef.current = delay;

    useEffect(() => {
        return playerWonEvents.subscribe(gameId, (data) => {
            setTimeout(
                () => {
                    playerWonEntity.store(gameId).update(data);
                },
                partnerSettingsStore.getGameDelay(gameId) + delayRef.current,
            );
        });
    }, []);

    useAfterUpdate(() => {
        const identifier = wonInfo?.betId || wonInfo?.runId;

        if (!wonInfo) {
            setLastIdentifier(null);
        } else if (identifier && identifier !== lastIdentifier) {
            setLastIdentifier(identifier);
            callback?.(wonInfo, identifier);
        }
    }, [wonInfo?.runId, wonInfo?.betId]);

    return lastIdentifier;
};
